"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
function initialize(init) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var pendoAnalytics = window.pendo;
    if (pendoAnalytics) {
        pendoAnalytics.initialize(init);
    }
}
exports.initialize = initialize;
